import type { IPhotoCaptureMetadata } from '../compiler/photoCapture.interface';
import type { DeliveryPhotoLocationPanelProps } from '../components/dialogs/DeliveryPhotoLocationPanel';
import { toBangkokDayjs } from './bangkokDateTime';

/** Never substitute the destination, submission location or image upload time. */
export function getDeliveryPhotoLocation(
  capture?: IPhotoCaptureMetadata | null,
): DeliveryPhotoLocationPanelProps['location'] {
  if (!capture || capture.schema_version !== 1) return undefined;
  const capturedAt = toBangkokDayjs(capture.captured_at);
  const locationAt = toBangkokDayjs(capture.location_timestamp);
  const sampleAge = capturedAt && locationAt ? capturedAt.diff(locationAt) : null;
  const freshDeviceSample = capture.location_source === 'device_gps'
    && sampleAge !== null && sampleAge >= -5000 && sampleAge <= 60000;
  return {
    latitude: capture.location_source === 'device_gps' ? capture.latitude : undefined,
    longitude: capture.location_source === 'device_gps' ? capture.longitude : undefined,
    source: freshDeviceSample ? 'photo_gps' : 'unverified',
    capturedAt: capture.captured_at,
    accuracyMeters: capture.location_source === 'device_gps' ? capture.accuracy_meters ?? undefined : undefined,
    locationRecordedAt: capture.location_source === 'device_gps' ? capture.location_timestamp : undefined,
  };
}
